export default "Fisketryk med en ægte fisk er meget simpelt, og resultaterne bliver de rene kunstværker!\n**Denne aktivitet kan også laves hjemme.**";